import { render } from "./MyLogin_side.vue?vue&type=template&id=6ae7c20e"
import script from "./MyLogin_side.vue?vue&type=script&lang=js"
export * from "./MyLogin_side.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__